import { get, post, put, del } from '../utils/makeRequest';

const USERS_ENDPOINTS = {
  GET_USERS: '/admin/users',
  GET_USER_BY_ID: '/admin/users',
  UPDATE_USER: '/admin/users',
  DELETE_USER: '/admin/users',
};

export const usersService = {
  /**
   * Get all users with role 'user'
   * @returns {Promise} - List of users
   */
  getUsers: async () => {
    return get(USERS_ENDPOINTS.GET_USERS);
  },

  /**
   * Get user by ID
   * @param {string} userId - User ID
   * @returns {Promise} - User data
   */
  getUserById: async (userId) => {
    return get(`${USERS_ENDPOINTS.GET_USER_BY_ID}/${userId}`);
  },

  /**
   * Create a new user
   * @param {object} userData - User data including name, email, password, etc.
   * @returns {Promise} - Created user data
   */
  createUser: async (userData) => {
    return post(USERS_ENDPOINTS.GET_USERS, userData);
  },

  /**
   * Update user
   * @param {string} userId - User ID
   * @param {object} userData - Updated user data
   * @returns {Promise} - Updated user data
   */
  updateUser: async (userId, userData) => {
    return put(`${USERS_ENDPOINTS.GET_USERS}/${userId}`, userData);
  },

  resendVerificationEmail: async (userId) => {
    return post(`${USERS_ENDPOINTS.GET_USERS}/${userId}/resend-verification`);
  },

  /**
   * Delete user
   * @param {string} userId - User ID
   * @returns {Promise} - Deletion result
   */
  deleteUser: async (userId) => {
    return del(`${USERS_ENDPOINTS.DELETE_USER}/${userId}`);
  },

  /**
   * Get API logs for a specific user (admin)
   * @param {string|number} userId
   * @param {{ limit?: number }} [options]
   */
  getUserApiLogs: async (userId, options = {}) => {
    const limit = options.limit || 50;
    return get(
      `${USERS_ENDPOINTS.GET_USERS}/${userId}/api-logs?limit=${limit}`
    );
  },
};
